import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { Title } from '@angular/platform-browser';
import { UserService } from './services/user.service';
import { TokenStorageService } from './token-storage.service';
import { Observable } from 'rxjs';
import { LoginCommunicationService } from './login-communication.service';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  title = 'IIIT-B 360';

  constructor(
    private router: Router,
    private tokenStorage: TokenStorageService,
    private loginCommunicationService: LoginCommunicationService,
    private userService: UserService,
    private titleService: Title,
    private iconSetService: IconSetService
  ) {
    titleService.setTitle(this.title);
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.loginCommunicationService.loginStatusChanged.subscribe(
      () => {
        console.log("Login status changed");
        this.loadUser();
      })

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
    this.loadUser();
    console.log("USER API called");
  }

  loadUser() {
    this.userService.loadUser().subscribe((data: any) => {
      if (data && data.returnCode === 200) {
        this.tokenStorage.saveUserDetails(data.result);
      }
    })
  }
}
